import { COMMA, NEW_LINE_RN, TAB_CHARACTER } from "./frfr-string-consts";


const frfr_lib_changes_id = '/FRFR/frfr-frontend-db.js/changes_id2024-04-15r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-csv-utils // CSV UTILS
Version ID: 1a 2023-04-27r1
by 
// Please describe here if you customized this file
*/

/*
DOKUMENTACIJA:

https://en.wikipedia.org/wiki/Comma-separated_values
Common Format and MIME Type for Comma-Separated Values (CSV) Files
https://datatracker.ietf.org/doc/html/rfc4180

*/

const NEW_LINE = NEW_LINE_RN;
const TAB = TAB_CHARACTER;

// za CSV
// https://developer.mozilla.org/en-US/docs/Glossary/CRLF



// csv_utils_extract_csv_rows_by_newlines
export const csv_utils_extract_csv_rows_by_newlines = (csv) => {
  // Make array of csv strings. Each item in array will be extracted single csv row.
  let rows = [];
  function splitLines(t) { return t.split(/\r\n|\r|\n/); } // https://stackoverflow.com/questions/21895233/how-in-node-to-split-string-by-newline-n
  rows = splitLines(csv);
  return rows;
};


//
export const csv_utils_extract_csv_rows_by_per_row = (csv, itemPerRow) => {
  let rows = [];
  let fullArr = csv.split(COMMA);
  let i = 0;
  let maxi = fullArr.length;
  // console.log('maxi', maxi);
  while (i <= maxi) {
    // console.log(i);
    rows.push(
      fullArr.slice(i, i + itemPerRow - 1)
    );
    i += itemPerRow - 1;
  }
  return rows;
};


/*
https://stackoverflow.com/questions/9118769/when-to-use-the-terms-delimiter-terminator-and-separator


A delimiter is one or two markers that show the start and end of something. They're needed because we don't know how long that 'something' will be. We can have either: 1. a single delimiter, or 2. a pair of pair-delimiters

[a, b, c, d, e] each comma (,) is a single delimiter. The left and right brackets, ([, ]) are pair-delimiters.
"hello", the two quote symbols (") are pair-delimiters
A seperator is a synonym of a "delimiter", but from my experience it usually refers to field delimiters. A field delimiter acts as a divider between one field and the one following it, which is why is can be though of as "separating" them.

<file1>␜<file2>␜<file3>, the file separator character (␜), despite explicitly the name having "separator", is both a delimiter and a separator
A terminator marks the end of a group of things, again needed because we don't know how long it is.

abdefa\0, here the null character \0 is a terminator that tells us the string has ended.
foo\n, here the newline character \n is a terminator that tells us the line has ended.
The terms, delimiter, separator originate from the classical idea of storage, conceptually, being comprised of files, records, and fields, (a file has many records, a record has many fields). In this context, a single delimiter and pair-delimiters might be called record delimiters and field delimiters. Because of the historical significance of files-records-field taxonomy, this terms have a more widespread usage (see Wikipedia page for Delimiter).
https://en.wikipedia.org/wiki/Delimiter


A delimiter denotes the limits of something, where it starts and where it ends. For example:
"this is a string"
has two delimiters, both of which happen to be the double-quote character. The delimiters indicate what's part of the thing, and what is not.

A separator distinguishes two things in a sequence:
one, two

The role of a separator is to demarcate two distinct entities so that they can be distinguished. (Note that I say "two" because in computer science we're generally talking about processing a linear sequence of characters).

A terminator indicates the end of a sequence. In a CSV, you could think of the newline as terminating the record on one line, or as separating one record from the next.

*/


//
export const csv_utils_csv_to_array_of_arrays = (csv, separator) => {
  // console.log(csv);
  let _separator = COMMA;
  if (typeof separator === 'string') {
    _separator = separator;
  }
  if (typeof csv !== 'string' && typeof csv !== 'number') {
    csv = '';
  } else if (typeof csv === 'number') {
    csv = csv.toString();
  };
  // console.log(csv);
  let result = []; // array of arrays
  // let csvRows = csv.split(NEW_LINE);
  let csvRows = csv_utils_extract_csv_rows_by_newlines(csv);
  csvRows.forEach(r => {
    let rowExploded = r.split(_separator);
    result.push(rowExploded);
  });
  return result;
};


//
export const csv_utils_array_to_csv_row = (arr, separator) => {
  let csvRow = '';
  let _separator = COMMA;
  if (typeof separator === 'string') {
    _separator = separator;
  }
  arr.forEach((item, index) => {
    if (index !== (arr.length - 1)) {
      csvRow += item + _separator;
    } else {
      // last item without comma
      csvRow += item;
    }
  });
  // csv row ending with NEW LINE
  csvRow += NEW_LINE;
  return csvRow;
};


//
export const csv_utils_csv_to_array_of_objects = (csv, separator, skip_last_empty_row = true) => {
  // console.log(csv);
  const array_of_objects = []; // array of objects
  //
  let _separator = COMMA;
  if (typeof separator === 'string') {
    _separator = separator;
    if (separator === "_TAB_CHARACTER_") {
      _separator = TAB_CHARACTER;
    } else {
      _separator = separator;
    }
  }
  if (typeof csv !== 'string' && typeof csv !== 'number') {
    csv = '';
  } else if (typeof csv === 'number') {
    csv = csv.toString();
  };
  // console.log(csv);
  // let csvRows = csv.split(NEW_LINE);
  let _last_row_index = -1;
  const csvRows = csv_utils_extract_csv_rows_by_newlines(csv);
  if (skip_last_empty_row === true && csvRows.length > 1) {
    _last_row_index = csvRows.length - 1;
  }
  let column_keys = [];
  csvRows.forEach((r, index) => {
    if (index === 0) {
      // take column keys from first row
      let firstRowExploded = r.split(_separator);
      firstRowExploded.forEach((key) => {
        if (!column_keys.includes(key)) {
          column_keys.push(key);
        }
      });
    } else {
      const row_obj = {};
      let rowExploded = r.split(_separator);
      column_keys.forEach((key, index) => {
        row_obj[key] = rowExploded[index];
      });
      // array_of_objects.push(row_obj);
      // console.log('rowExploded', rowExploded);
      // console.log(index, _last_row_index);
      if (_last_row_index > -1 && index === _last_row_index && rowExploded.length === 1 && rowExploded[0] === '') {
        // skip last empty row
      } else {
        array_of_objects.push(row_obj);
      }
    }
  });
  return array_of_objects;
};

